import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { ProfileInvitesState } from './profile-invites.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'profile-invites', resettable: true, idKey: 'id' })
export class ProfileInvitesStore extends EntityStore<ProfileInvitesState> {
  constructor() {
    super();
  }
}
